<template>
  <div>
    <header>
      <!-- <HeaderTop class="ts-bg-white" /> -->
      <HeaderBottom class="ts-bg-white ts-border-b ts-border-gray-200" />
    </header>
      <router-view></router-view>
    <footer>
      <Footer />
    </footer>
  </div>
</template>

<script>
import HeaderTop from './components/header/header-top'
import HeaderBottom from './components/header/header-bottom'
import Footer from './components/footer'

export default {
  components: {
    HeaderTop,
    HeaderBottom,
    Footer
  },
  data() {
    return {
      isOpen: false
    }
  }
}
</script>